import { Core } from "@faire/design-tokens";
import { localNum } from "@faire/web/common/localization";
import { Opacity } from "@faire/web/slate/Color";
import { Column } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { TransparencyOverlay } from "@faire/web/ui/TransparencyOverlay";
import React from "react";
import styled from "styled-components";

export const ImageOverlay = ({
  extraProductsCount,
  smallCount,
}: {
  extraProductsCount?: number;
  smallCount?: boolean;
}) => {
  return (
    <>
      {extraProductsCount ? (
        <Overlay>
          <Typography
            variant={
              smallCount ? "paragraphSansMedium" : "sectionHeaderSansMedium"
            }
            color={Core.text.inverse}
            align="center"
          >
            <StrictLocalMsg
              defaultMessage="+{countNumber}"
              description={{
                text: "A counter showing the number of extra products in a list",
                img: "https://cdn.faire.com/fastly/f037b34cba4e7fac281649303451bc64211498377b9db0c3076da1479e8d3daa.png",
              }}
              values={{ countNumber: localNum(extraProductsCount) }}
            />
          </Typography>
        </Overlay>
      ) : (
        <TransparencyOverlay />
      )}
    </>
  );
};

const Overlay = styled(Column).attrs({
  align: "center",
  justify: "center",
})`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${Core.surface.default + Opacity.O_50};
  padding: ${getSpacing("1x")};
`;
